module.exports = __webpack_public_path__ + "static/media/podium-icon.193d8d0f.svg";